// extracted by mini-css-extract-plugin
module.exports = {"tabs":"index_tabs_1EJzN","page":"index_page_293X6"};